var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUploadIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "30px",
    height: "22px",
    viewBox: "0 0 30 22",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Fill 1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Owner",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Owner---folders-shared-with-me",
    transform: "translate(-790.000000, -364.000000)",
    fill: "#E2E8F6"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-8",
    transform: "translate(790.000000, 364.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.9999302,0.000348837209 C17.2319302,0.000348837209 19.4667907,0.847918605 21.1701628,2.55122093 C22.6159186,3.99697674 23.4484884,5.82293023 23.6665116,7.70738372 C27.2204651,8.03033023 30,11.0131744 30,14.6513372 C30,18.5049419 26.8768256,21.6280814 23.0232558,21.6280814 L5.93023256,21.6280814 C2.64488372,21.6280814 0,18.9831977 0,15.6978488 C0,12.4125 2.64488372,9.76761628 5.93023256,9.76761628 L6.34447674,9.76761628 C6.03651977,7.20174419 6.87181395,4.52005814 8.84082558,2.55087209 C10.5441279,0.847569767 12.7680349,-3.19744231e-14 14.9998953,-3.19744231e-14 L14.9999302,0.000348837209 Z M14.9999302,7.32589274 C14.8146105,7.32456628 14.6851605,7.35999767 14.5311628,7.50034884 L10.6939535,10.9887209 C10.4214244,11.2339953 10.371007,11.7122791 10.6394477,11.9807442 C10.8983512,12.2396477 11.3602849,12.2709872 11.6314709,12.0243488 L14.3022384,9.59337209 L14.3022384,17.0933721 C14.3022384,17.4790116 14.6142837,17.7910465 14.9999128,17.7910465 C15.3855419,17.7910465 15.6975872,17.4790012 15.6975872,17.0933721 L15.6975872,9.59337209 L18.3683547,12.0243488 C18.6395198,12.2709872 19.1137151,12.2532733 19.3603779,11.9807442 C19.6070407,11.7082151 19.5920267,11.2381047 19.3058721,10.9887209 L15.4686628,7.50034884 C15.3691884,7.40905116 15.1865965,7.3300186 14.9998953,7.32589274 L14.9999302,7.32589274 Z",
    id: "Fill-1"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadIcon);
export default __webpack_public_path__ + "static/media/upload_icon.e141402820f9442630ed57b59fb24393.svg";
export { ForwardRef as ReactComponent };